module.exports = ".fa {\n  vertical-align: middle; }\n\n.load, .cont-load {\n  width: 20px;\n  height: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.scss
// module id = ./src/app/shared/loader/loader.component.scss
// module chunks = main